import { PageHeader, PageShell } from '~/components/layout';
import { Button, Card, CardBody, EmptyState } from '~/components/ui';
import { routes } from '~/app/routes';

/** The `*` route: an unknown path gets a real page with a way back, never an empty shell. */
export function NotFoundPage() {
  return (
    <PageShell>
      <PageHeader title="Page not found" />
      <Card>
        <CardBody>
          <EmptyState
            title="This page does not exist"
            description="The link may be out of date or mistyped. Go back to the dashboard to find what you need."
            action={
              <Button variant="outline" href={routes.dashboard}>
                Go to dashboard
              </Button>
            }
          />
        </CardBody>
      </Card>
    </PageShell>
  );
}
